import { H1, P } from '../../components/elements/Text';
import Navbar from '../../components/Navbar';
import PageWithAsyncData from '../../components/PageWithAsyncData';
import { useParams } from 'react-router-dom';
import {
  useGetCompany,
  useGetCompanyProjectSubmissions,
} from '../../hooks/use-hydra/admin';
import day from 'dayjs';
import utc from 'dayjs/plugin/utc';

import CompanyPageWrapper from '../../components/Admin/CompanyPageWrapper';
import { COMPANY_PAGES } from '../../components/Admin/CompanySideNavigation';
import CompanyProjects from '../../components/Admin/CompanyProjects';
import { ROUTES } from '../../routing';
day.extend(utc);

const NavbarWithBreadcrumbs = ({
  name,
  companyId,
}: {
  name?: string;
  companyId: string;
}) => (
  <Navbar
    breadCrumbs={[
      {
        label: 'Home',
        url: ROUTES.HOME.getPath(),
      },
      {
        label: 'Teams',
        url: ROUTES.ADMIN.COMPANIES.getPath(),
      },
      {
        label: name || 'Company',
        url: ROUTES.ADMIN.COMPANY.getPath({ companyId }),
      },
      {
        label: 'Company Projects',
        url: null,
      },
    ]}
  />
);

export default function CompanyProjectsPage() {
  const { id } = useParams<{ id: string }>();
  const { data, isLoading, error, refetch } = useGetCompany(parseInt(id));
  const { isLoading: isSubmissionsLoading } = useGetCompanyProjectSubmissions(
    parseInt(id)
  );
  return (
    <PageWithAsyncData
      isLoading={isLoading || isSubmissionsLoading}
      error={error}
      retry={refetch}
      noScroll
    >
      <NavbarWithBreadcrumbs name={data?.name} companyId={id} />
      <CompanyPageWrapper currentPage={COMPANY_PAGES.COMPANY_PROJECTS}>
        <H1>{data?.name} Company Projects</H1>
        <P>
          Track learner progress through their company project journey - from
          first check-in #1 and #2, to final project submission.
        </P>
        <CompanyProjects companyId={parseInt(id)} />
      </CompanyPageWrapper>
    </PageWithAsyncData>
  );
}
